// extracted by mini-css-extract-plugin
export default {"body":"TernsOfUse_body__1rnWB","openingText":"TernsOfUse_openingText__YXT9I"};